export const president = [
  ["總召", "張馨予 Alice"],
  ["副召", "呂沂柔 Ashley"],
  ["執行秘書", "葉妮箏 Hina"],
];
export const directors = [
  ["企劃部部長", "曹心慧 Eileen"],
  ["講者部部長", "董品慧 Nancy"],
  ["行銷設計部部長", "鄭心妍 Chyenne"],
  ["公關部部長", "陳宜榛 Hazel"],
];
